"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeeCoefficientForVehicleType = getFeeCoefficientForVehicleType;
const roundToDecimalPlaces_1 = require("../roundToDecimalPlaces");
const SEDAN_LITE_MARGIN_MULTIPLIER = 1.11;
function getFeeCoefficientForVehicleType(baseFeeCoefficient, vehicleType) {
    // sedan lite
    if (vehicleType === 100) {
        const feePart = 1 - baseFeeCoefficient;
        const increasedFeePart = (0, roundToDecimalPlaces_1.ceilToDecimalPlaces)(feePart * SEDAN_LITE_MARGIN_MULTIPLIER, 3);
        return (0, roundToDecimalPlaces_1.roundToDecimalPlaces)(1 - increasedFeePart, 3);
    }
    return baseFeeCoefficient;
}
//# sourceMappingURL=getFeeCoefficientForVehicleType.js.map